export const formatAvatarInitials = (labels: [string] | [string, string]) => {
  const [first, last] = labels

  if (!first && !last) {
    return null
  }

  return [first?.at?.(0), last?.at?.(0)].filter(Boolean).join('')
}
